import styled from 'styled-components';

export const AllTaskCompletedWrapper = styled.div`
  display: flex;
  min-width: 200px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.green1};
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
